import * as React from 'react';
import './paymentMethodSelector.module.scss';
import { SelectInput } from '../../../../commonv3/components/atoms/forms/primitive/SelectInput';

function getLabel(installments: number) {
  if (installments === 1) {
    return '一括払い';
  }
  return `${installments}回払い`;
}

type Props = {
  id?: string;
  title: string;
  price: number;
  price_with_tax: number;
  value: number;
  options: number[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (nextInstallments: number) => any;
};

export class PaymentMethodSelector extends React.Component<Props> {
  render() {
    const { id, title, price, price_with_tax, value, options, onChange } = this.props;
    return (
      <div id={id} styleName="selector">
        <div styleName="title">{title}</div>
        <div styleName="body">
          <div styleName="price">
            <div styleName="without-tax">
              <span styleName="price-number">{price.toLocaleString()}</span>円
            </div>
            <div styleName="with-tax">（税込 {price_with_tax.toLocaleString()}円）</div>
          </div>
          {price > 0 && options.length > 1 && (
            <SelectInput
              id="installments"
              value={value.toString()}
              onChange={(v) => onChange && onChange(Number(v))}
              options={options.map((opt) => ({ label: getLabel(opt), value: opt.toString() }))}
              serializer={(v) => v}
              deserializer={(v) => v}
            />
          )}
          {price > 0 && options.length == 1 && <span styleName="label">{getLabel(options[0])}</span>}
        </div>
      </div>
    );
  }
}
